/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'sarsaparilla';

const propTypes = {
    permitID: PropTypes.string,
    reservationID: PropTypes.string,
    cooperator: PropTypes.object,
    onChangeCooperator: PropTypes.func,
    isDisabled: PropTypes.bool,
};

const defaultProps = {
    isDisabled: false,
};

export default class CooperatorDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <h2 className={'h5'}>Cooperator or Issuing Station</h2>
                {this.props.cooperator && (
                    <div className="rec-grid-12-12 cooperator-details rec-section-outer-wrap">
                        <div className="rec-nested-wrap">
                            <div className="rec-grid-6-12">
                                <table>
                                    <tbody>
                                        <tr className="cooperator-row rec-nested-wrap">
                                            <td>
                                                <strong>Location:</strong>
                                            </td>
                                            <td>
                                                <span>{this.props.cooperator.name}</span>
                                            </td>
                                        </tr>
                                        {(this.props.cooperator.website_url && (
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Website:</strong>
                                                </td>
                                                <td className="cooperator-row-info">
                                                    <a
                                                        href={
                                                            this.props.cooperator
                                                                .website_url
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {
                                                            this.props.cooperator
                                                                .website_url
                                                        }
                                                    </a>
                                                </td>
                                            </tr>
                                        )) ||
                                            null}
                                        {(this.props.cooperator.email && (
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Email:</strong>
                                                </td>
                                                <td>
                                                    <span>
                                                        {this.props.cooperator.email}
                                                    </span>
                                                </td>
                                            </tr>
                                        )) ||
                                            null}
                                        {(this.props.cooperator.phone && (
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Phone:</strong>
                                                </td>
                                                <td>
                                                    <span>
                                                        {this.props.cooperator.phone}
                                                    </span>
                                                </td>
                                            </tr>
                                        )) ||
                                            null}
                                        {(this.props.cooperator.city && (
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Address:</strong>
                                                </td>
                                                <td>
                                                    <p>
                                                        {this.props.cooperator.address1}
                                                    </p>
                                                    <p>
                                                        {this.props.cooperator.address2}
                                                    </p>
                                                    <p>
                                                        {this.props.cooperator.city}
                                                        {this.props.cooperator
                                                            .state_code &&
                                                            ` ${this.props.cooperator.state_code}`}
                                                        , {this.props.cooperator.zip_code}
                                                    </p>
                                                </td>
                                            </tr>
                                        )) ||
                                            null}
                                        {(this.props.cooperator.driving_directions && (
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Directions:</strong>
                                                </td>
                                                <td>
                                                    <span>
                                                        {
                                                            this.props.cooperator
                                                                .driving_directions
                                                        }
                                                    </span>
                                                </td>
                                            </tr>
                                        )) ||
                                            null}
                                    </tbody>
                                </table>
                            </div>
                            {this.props.cooperator.hours && (
                                <div className="rec-grid-6-12">
                                    <table>
                                        <tbody>
                                            <tr className="cooperator-row">
                                                <td>
                                                    <strong>Hours:</strong>
                                                </td>
                                                <td>
                                                    <pre>
                                                        {this.props.cooperator.hours}
                                                    </pre>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <button
                    type="button"
                    className="rec-button-link"
                    disabled={this.props.isDisabled}
                    onClick={this.props.onChangeCooperator}
                >
                    <Icon iconName="edit" />I need to make a change
                </button>
                <hr />
            </div>
        );
    }
}

CooperatorDetails.propTypes = propTypes;
CooperatorDetails.defaultProps = defaultProps;
